import { Component } from '@angular/core';
import { MiscPartTimeEmployee } from '../../models/models';
import { AbstractControl } from '@angular/forms';
import { BaseEditFormComponent } from '../../../shared/base-edit-form/base-edit-form.component';

@Component({
  selector: 'tbody[lsz-part-time-employee-misc-typed-form]',
  templateUrl: './part-time-employee-misc-typed-form.component.html',
  styleUrls: ['./part-time-employee-misc-typed-form.component.css'],
})
export class PartTimeEmployeeMiscTypedFormComponent extends BaseEditFormComponent<MiscPartTimeEmployee> {

  public get fullTimePersonnel(): AbstractControl {
    return this.form.get('fullTimePersonnel');
  }

  public get partTimePersonnel(): AbstractControl {
    return this.form.get('partTimePersonnel');
  }

  constructor() {
    super();
  }

  public onClickSave(): void {
    this.entrySaved.emit({
      ...this.entry,
      fullTimePersonnel: this.fullTimePersonnel.value as number,
      partTimePersonnel: this.partTimePersonnel.value as number,
    } as MiscPartTimeEmployee);
  }
}
